import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { AiOutlineMail } from 'react-icons/ai';
import { BsPencil } from 'react-icons/bs';
import { TbLicense } from 'react-icons/tb';
import { useSelector } from 'react-redux';

const RealEstateData = () => {
  const realEstateData = useSelector(state => state.realEstate.data);

  return (
    <Card className="bg-white mt-3">
      <Card.Header className="border-bottom">
        <Card.Title>Ficha de Información</Card.Title>
      </Card.Header>

      <Card.Body>
        {realEstateData && (
          <Row className="g-3">
            <Col xs={12}>
              <span className="logo-normal">
                <BsPencil size={18} /> Nombre:
              </span>

              <span>{realEstateData.name}</span>
            </Col>

            <Col xs={12}>
              <span className="logo-normal">
                <TbLicense size={18} /> Matrícula:
              </span>

              <span>{realEstateData.matricula || 'No especificada'}</span>
            </Col>

            <Col xs={12}>
              <span className="logo-normal d-block d-md-inline">
                <AiOutlineMail size={18} /> Correo:
              </span>

              <span>
                {realEstateData.email ? (
                  <a href={`mailto:${realEstateData.email}`}>
                    {realEstateData.email}
                  </a>
                ) : (
                  'Sin correo'
                )}
              </span>
            </Col>

            <Col xs={12} className="text-danger fs--2">
              * Los datos de la inmobiliaria solo pueden modificarse a través
              del departamento de Atención al Matriculado. Para consultas enviar
              un mail a: cabaprop@colegioinmobiliario.org.ar
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

export default RealEstateData;
